"use client";

import { useMemo } from "react";
import type { VideoFeedLabels } from "@/components/ui/design-system/video-feed";
import { useCreatorTranslations } from "@/i18n/creator/useCreatorTranslations";

/**
 * The feed's copy from the creator catalogue, so NewForm One's feeds speak
 * the creator's language. The feed itself is a design-system component and
 * defaults to English.
 */
export function useCreatorVideoFeedLabels(): VideoFeedLabels {
  const t = useCreatorTranslations("videos.feed");
  return useMemo(
    () => ({
      close: t("close"),
      mute: t("mute"),
      unmute: t("unmute"),
      play: t("play"),
      pause: t("pause"),
      previous: t("previous"),
      next: t("next"),
      loadingMore: t("loadingMore"),
      end: t("end"),
      failed: t("failed"),
      retry: t("retry"),
    }),
    [t],
  );
}
